import { APP_BAR_HEIGHT } from '@fdha/web-ui-library';

export const CONTENT_HEIGHT = `calc(100vh - ${APP_BAR_HEIGHT}px)`;
